<template>
  <div
    id="Account"
    class="pb-2"
  >
    <v-title>
      <font-awesome-icon icon="user-cog" />
      帳號更新
      <v-font
        v-if="Privilege === 'false'"
        slot="etext"
        font-css="ml-4"
        font-text="Account Management"
      />
    </v-title>
    <hr>
    <div class="tab-content">
      <!-- 權限管理主版 -->
      <ul
        class="nav nav-tabs lh-fs"
        role="tablist"
      >
        <!-- 頁簽-帳號管理 -->
        <v-link
          v-if="Privilege === 'true'"
          link-text="帳號管理"
          link-router="#/admin/account/user"
          link-control="auser"
          link-select="true"
          :link-type="active1"
          @click.native="FeeorderList(1)"
        />
        <!-- 頁簽-個人資料 -->
        <v-link
          v-if="Privilege === 'true'"
          link-text="個人資料"
          link-router="#/admin/account/edituser"
          link-control="huser"
          link-select="false"
          :link-type="active2"
          @click.native="FeeorderList(2)"
        />
        <!-- 頁簽-前台查詢帳號 -->
        <v-link
          v-if="Privilege === 'true'"
          link-text="前台帳號查詢"
          link-router="#/admin/account/queryuser"
          link-control="quser"
          link-select="false"
          :link-type="active3"
          @click.native="FeeorderList(3)"
        />
        <!-- user個資 -->
        <v-link
          v-if="Privilege === 'false'"
          link-text="人員資料變更"
          link-router="#/home/account/user"
          link-control="husers"
          link-select="false"
          link-type="active"
        >
          <br slot="linkbr">
          <v-font
            slot="linkfont"
            font-css="spanfs"
            font-text="Change User's Information"
          />
        </v-link>
      </ul>
      <!-- 帳號管理 -->
      <AdUser v-if="isActiveAd && Privilege === 'true'" />
      <!-- 個人資料 -->
      <AeUser v-if="isActiveAe && Privilege === 'true'" />
      <!-- 前台查詢帳號 -->
      <QUser v-if="isActiveQu && Privilege === 'true'" />
      <!-- user個資 -->
      <User v-if="Privilege === 'false'" />
    </div>
  </div>
</template>

<script>
import VLink from '@/components/Features/AccountLink.vue'
import AdUser from './UserReview'
import AeUser from './AdminUser'
import QUser from './Query_User'
import User from './User'
export default {
  components: {
    VLink,
    AdUser,
    AeUser,
    QUser,
    User
  },
  data () {
    return {
      Privilege: sessionStorage.getItem('BackendPrivilege') ? 'true' : 'false',
      isActiveAd: true,
      isActiveAe: false,
      isActiveQu: false,
      active1: 'active',
      active2: '',
      active3: ''
    }
  },
  methods: {
    FeeorderList (data) {
      const vm = this
      if (data === 1) {
        vm.isActiveAd = true
        vm.isActiveAe = false
        vm.isActiveQu = false
        vm.active1 = 'active'
        vm.active2 = ''
        vm.active3 = ''
      } else if (data > 1 && data < 3) {
        vm.isActiveAd = false
        vm.isActiveAe = true
        vm.isActiveQu = false
        vm.active1 = ''
        vm.active2 = 'active'
        vm.active3 = ''
      } else {
        vm.isActiveAd = false
        vm.isActiveAe = false
        vm.isActiveQu = true
        vm.active1 = ''
        vm.active2 = ''
        vm.active3 = 'active'
      }
    }
  }
}
</script>
